import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const translationRulesRequest = createAction(
  types.TRANSLATION_RULES_REQUEST,
);
export const translationRulesSuccess = createAction(
  types.TRANSLATION_RULES_SUCCESS,
);
export const translationRulesFailure = createAction(
  types.TRANSLATION_RULES_FAILURE,
);

export const setTranslation = createAction(types.SET_TRANSLATION_RULES);
